import React from 'react';
import AdminHeader from '../../globals/Layout/Admin/AdminHeader';
import TTag from './Tables/TTag';
const Tag: React.FC = () => {
    return (
        <div>
            <AdminHeader>Tag</AdminHeader>  
            <TTag/>        
        </div>

    );
};


export default Tag;